export const JUSTIFY_SELF_CLASSES = {
    auto: 'justify-self-auto',
    start: 'justify-self-start',
    end: 'justify-self-end',
    center: 'justify-self-center',
    stretch: 'justify-self-stretch',
};
export const applyJustifySelf = (justifySelf) => [
    ...(justifySelf ? [JUSTIFY_SELF_CLASSES[justifySelf]] : []),
];
